<div class="dashboard">
  @if (!groupMode) {
  <top-bar
    [showSessionSyncButton]="canUseTwoToOneSessionSync()"
    [sessionSyncRunning]="isTwoToOneSessionSyncRunning()"
    (sessionSyncToggle)="toggleTwoToOneSessionSync()"
  ></top-bar>
  }

  @if (!isPreview && (!sessionID || !patientID)) {
  <div class="text-center w-100 mt-5 text-danger">
    Invalid session or patient
  </div>
  }
  
  @if (!loading && sessionID && patientID && isSessionDeleted()) {
    <div class="text-center w-100 mt-5 text-danger mb-5">
      Session Deleted. Redirecting to sessions...
    </div>
  }
  @if (sessionID && patientID && isSessionFinished()) {
  <div class="text-center w-100 mt-5 text-danger mb-5">
    @if (loading) {
    <app-loading-indicator />
    } @else {
      @if (justFinishedSession) {
      Session finished, redirecting...
      }
      @else {
      Session finished.
      }
    }
  </div>
  } @else {

  <div class="float-right me-3" *ngIf="!lightLoad.isEnabled()">
    <p-button (onClick)="bip.toggle($event)" label="BIP" id="bipComponentsButton" severity="success" [outlined]="true"
      [style]="{
        'border-radius': '5px',
        'font-weight': 'bold',
        
      }" />
    <p-overlayPanel #bip>
      <div class="side-menu-buttons">
        <a class="main-button" (click)="openBipView('QuickReference'); bip.hide()">
          <span>Quick Reference</span>
        </a>
        <a class="main-button" (click)="openBipView('Behaviors'); bip.hide()">
          <span>Behaviors</span>
        </a>
        <a class="main-button" (click)="openBipView('CrisisCycle'); bip.hide()">
          <span>Crisis Cycle</span>
        </a>
        <a class="main-button" (click)="openBipView('EmergencyProcedures'); bip.hide()">
          <span>Emergency Procedures</span>
        </a>
        <a class="main-button" (click)="openBipView('AdditionalInfo'); bip.hide()">
          <span>Additional Information</span>
        </a>
      </div>
    </p-overlayPanel>

  </div>

  <div class="float-right me-3 d-flex">
    <button class="badge-patient-instructions pointer ms-2" title="Reload Data"
      (click)="reloadData()"><i class="pi pi-refresh"></i></button>
     <button *ngIf="!lightLoad.isEnabled()" class="badge-patient-instructions pointer ms-2" title="Patient Instructions"
      (click)="openPatientInstructions()">?</button>
    </div>
  <ng-template #collectionHeading let-item>
    @if(item.ProgramID) {
      <div class="float-right d-flex flex-wrap gap-2 align-items-center">
        <label>Show Hidden Maintenance Targets <p-checkbox class="ms-2" [ngModel]="showMaintenanceTargetsOnProgram[item.ProgramID]" (ngModelChange)="toggleShowMaintenanceTargets(item.ProgramID)" [binary]="true" /></label>
        <label>Show Mastered Targets <p-checkbox class="ms-2" [ngModel]="showMasteredTargetsOnProgram[item.ProgramID]" (ngModelChange)="toggleShowMasteredTargets(item.ProgramID)" [binary]="true" /></label>
        <button *ngIf="!lightLoad.isEnabled()" class="badge-program-details pointer" (click)="openProgramDetails(item)">?</button>
      </div>
    }
  </ng-template>
  <ng-template #collectionNotes let-item>
    @if (item.ProgramID && !lightLoad.isEnabled()){
    <div class="program-notes" (click)="showProgramNotes(programNotesDiv, programNotesTextarea, item)"
      (clickOutside)="hideProgramNotes(programNotesDiv, programNotesTextarea)" #programNotesDiv>
      <div class="d-flex justify-content-between align-items-center">
        <span>Program Notes: <i style="font-size: 12px; opacity: 0.5;">{{ lastModifiedByTextForProgram(item) +
            (item.ProgramNotesLastModifiedDate != '' ? (item.ProgramNotesLastModifiedDate | date:'MM/dd/yyyy hh:mm a') :
            '') }}</i>
          <i class="pi pi-arrow-down" *ngIf="!programNotesTextarea.classList.contains('focused')"></i>
        </span>
        <div class="d-flex gap-2" *ngIf="!isPreview">
          <button *ngIf="isProgramNotesShowing && !isEditingProgramNotes" pButton
            class="p-button-outlined side-menu-button2" icon="pi pi-pencil"
            [disabled]="item.ProgramNotes == null || isLoadingProgramNotes"
            (click)="startEditingProgramNotes()">
            &nbsp;Edit
          </button>
          <div *ngIf="isEditingProgramNotes" class="d-flex gap-2">
            <button pButton class="p-button-outlined side-menu-button2" icon="pi pi-check"
              [disabled]="item.ProgramNotes == null"
              (click)="saveProgramNotes(item.ProgramID, item.ProgramNotes)">
              &nbsp;Save
            </button>
            <button pButton class="p-button-outlined switch-mode-button" icon="pi pi-times"
              (click)="cancelEditingProgramNotes()">
              &nbsp;Cancel
            </button>
          </div>
        </div>
      </div>
      @if (item.ProgramNotes == null && isProgramNotesShowing) {
        <div class="d-flex align-items-center gap-2 text-muted p-2" role="status">
          <div class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></div>
          <span>Loading program notes...</span>
        </div>
      }
      <textarea class="program-notes-textarea" #programNotesTextarea
        [hidden]="item.ProgramNotes == null"
        [ngModel]="item.ProgramNotes"
        (ngModelChange)="onProgramNotesChanged(item, $event)"
        [disabled]="!isEditingProgramNotes || item.ProgramNotes == null"></textarea>
    </div>
    }
    @if (item.TargetID && !lightLoad.isEnabled()){
    <div class="program-notes target-note-thread-menu">
      <div class="d-flex justify-content-between align-items-center">
        <span>Target Notes:</span>
      </div>
      <app-target-note-thread
        [targetId]="item.TargetID"
        [patientId]="patientID"
        [targetNotes]="item.TargetNotes"
        [notesLastModifiedByUserFullName]="item.TargetNotesLastModifiedByUserFullName"
        [notesLastModifiedDate]="item.TargetNotesLastModifiedDate"
        [readOnly]="isPreview"
        [shouldMarkAsNew]="true"
        (latestMessageChanged)="onMenuTargetNoteChanged(item, $event)"
      ></app-target-note-thread>
    </div>
    }

  </ng-template>
  <app-session-collection [ready]="(isPreview || !!(sessionID && patientID)) && !loading" [started]="isStarted()"
    [preview]="isPreview" [showSessionControls]="!groupMode" [busy]="isStartingSession" [timerText]="timerString()"
    [favoriteTargets]="favoriteTargets" [specialFavoriteTargets]="specialFavoriteTargets" [behaviors]="behaviors"
    [groups]="groupedShowingItems" [targetVisible]="collectionTargetVisible" [subTargetsDictionary]="subTargetsDictionary" [promptSchedules]="promptSchedules"
    [programInstructions]="!lightLoad.isEnabled()" [headingTemplate]="collectionHeading" [notesTemplate]="collectionNotes" [navigation]="collectionNavigation"
    [playlistTitle]="selectedPlaylistIndex >= 0 ? filteredPlaylists[selectedPlaylistIndex]?.PlaylistName ?? '' : ''"
    [showPlaylistDetails]="!lightLoad.isEnabled()" [allowSearch]="true" [showSearch]="showFilterDialog" [searchText]="filterText"
    (start)="startSession()" (end)="endSession()" (programDetails)="openProgramDetails($event)" (playlistDetails)="openPlaylistDetails()"
    (navigationSelected)="selectCollectionItem($event)" (searchTextChange)="filterText = $event; filterPrograms()"
    (searchToggle)="showFilter()" (clearSearch)="clearSearchInput()" (next)="nextOnList()">
    <ng-container session-reminders>  <div class="reminder-container">
    @for (reminder of showingReminders; track reminder.ID) {
    <div class="alert alert-danger" role="button" (click)="closeReminder(reminder)">
      @if (reminder.Message?.trim()) {
      <span class="m-0 p-0">{{ reminder.Message }}</span>
      } @else {
      <span class="m-0 p-0">{{ reminder.Name + " (Reminder name shown because the message was empty)" }}</span>
      }
    </div>
    }
  </div>
</ng-container>
  </app-session-collection>
  }
</div>

<div class="progress-note" (clickOutside)="hideProgressNote()" *ngIf="supportProgressNote() && isStarted() && !loading">
  <div class="progress-note-text" (click)="showProgressNote()" [class.hide]="showingProgressNote">
    <span>Progress Note </span>
    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <i class="pi pi-arrow-right"></i></span>
  </div>

  <div class="progress-note-text" (click)="hideProgressNote()" [class.hide]="!showingProgressNote">
    <span>Progress Note </span>
    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="pi pi-arrow-left"></i></span>
  </div>
  <app-progress-note class="progress-note-inner" [isPreview]="isPreview" [PatientSessionID]="patientSession?.ID ?? 0"
    #progressNoteComponent (endSessionEvent)="endSession()" [targets]="targets" [behaviors]="behaviors"
    [programs]="programs" />
</div>
@if (showEndSession) {
<div class="staff-dialog-backdrop" (click)="onCloseEndSession()"></div>
<p-dialog header="End Session - Handoff" class="staff-dialog" [closable]="false" [visible]="true">
  <app-end-session
    [groupMode]="groupMode"
    (close)="onCloseEndSession()"
    (finished)="onEndSessionFinished($event)"
  />
</p-dialog>
}

@if (loading || isStartingSession) {
<app-loading-indicator />
}


@if (detailsOpened) {
<app-target-details [program]="programToShowDetails" (onCloseDetails)="onCloseDetails()" [isPreview]="isPreview"></app-target-details>
}

@if (playlistDetailsOpened) {
<div class="details-dialog-backdrop" (click)="closePlaylistDetails()"></div>
<dialog class="details-dialog" open>
  <h5 class="w-100 text-center">Playlist Instructions</h5>
  <div class="patient-instructions-body bg-white ">
    @if (isLoadingPlaylistContent && playlistToShowDetails?.Details == null) {
      <div class="d-flex align-items-center gap-2 text-muted p-3" role="status">
        <div class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></div>
        <span>Loading playlist instructions...</span>
      </div>
    } @else {
      <div class="ck ck-content text-black p-5 patient-staff-instructions border-small-rounded"
        [innerHTML]="playlistToShowDetails?.Details | safeHtml"></div>
    }
  </div>
  <div class="d-flex justify-content-end mt-2">
    <button class="side-menu-button2" (click)="closePlaylistDetails()">Close</button>
  </div>
</dialog>
}

<app-attachment-view
  [doShowAttachmentView]="doShowAttachmentView"
  [attachment]="selectedAttachment"
  [canDelete]="false"  
  [view]="'patientInstructionAttachment'"
  (close)="closeAttachmentView()"
></app-attachment-view>

@if (patientInstructionsOpened && !lightLoad.isEnabled()) {
<div class="details-dialog-backdrop" (click)="closePatientInstructions()"></div>
<dialog class="details-dialog" open>
  <h5 class="w-100 text-center">Patient General Instructions</h5>
  <div class="patient-instructions-body bg-white ">
    @if (isLoadingPatientInstructions && !hasLoadedPatientInstructions) {
      <div class="d-flex align-items-center gap-2 text-muted p-3" role="status">
        <div class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></div>
        <span>Loading patient instructions...</span>
      </div>
    } @else {
      <div class="ck ck-content text-black p-5 patient-staff-instructions border-small-rounded"
      [innerHTML]="patientInstructions | safeHtml"></div>
    }
  </div>
  @if(!isOfflineMode){
    <div style="width: 100%">
      <div class="att-list-container background-set-white border-small-rounded mt15">
        @if (isLoadingPatientInstructionAttachments && !hasLoadedPatientInstructionAttachments) {
          <div class="d-flex align-items-center gap-2 text-muted p-2" role="status">
            <div class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></div>
            <span>Loading attachments...</span>
          </div>
        }
        @for (att of instructionFiles; track att.ID) {
          <div class="att-box" role="button" (click)="openAttachmentView(att)">
            @if(att.IsImage){
              <img class="m-2" [src]="getImageUrl(att)" style="min-width: 40px; min-height: 40px; max-width: 40px; max-height: 40px;">
            }
            @else{
              <i class="m-0 p-0 pi pi-file-o" style="font-size: 25px; color: black;"></i>
            }
          </div>
        }
      </div>
    </div>
  }
  <div class="d-flex justify-content-end mt-2">
    <button class="side-menu-button2" (click)="closePatientInstructions()">Close</button>
  </div>
</dialog>
}

@if (showBipDialog && !lightLoad.isEnabled()) {
<div class="details-dialog-backdrop" (click)="closeBipView()"></div>
<dialog class="details-dialog" open>
  <div class="patient-instructions-body bg-white ">
    @if (bipView === 'QuickReference') {
      <app-bip-quick-reference [patientID]="(patientID ?? 0).toString()" [showToggle]="false" [isInStaffContext]="true" (strategySelected)="onQuickRefStrategySelected($event)" />
    }
    @if (bipView === 'Behaviors') {
      <app-bip-behaviors [patientID]="(patientID ?? 0).toString()" [showDraftToggle]="false" [scrollFragment]="bipScrollFragment" [useOfflineData]="isOfflineMode" />
    }
    @if (bipView === 'CrisisCycle') {
      <app-bip-crisis-cycle [patientID]="(patientID ?? 0).toString()" [showToggle]="false" [useOfflineData]="isOfflineMode" />
    }
    @if (bipView === 'EmergencyProcedures') {
      <app-bip-emergency-procedures [patientID]="(patientID ?? 0).toString()" [showToggle]="false" [useOfflineData]="isOfflineMode" />
    }
    @if (bipView === 'AdditionalInfo') {
      <app-bip-additional-info [patientID]="(patientID ?? 0).toString()" [showToggle]="false" [useOfflineData]="isOfflineMode" />
    }
  </div>
  <div class="d-flex justify-content-end mt-2">
    <button class="side-menu-button2" (click)="closeBipView()">Close</button>
  </div>
</dialog>
}
